<div  style="margin-bottom: 15px; margin-top: 10px;">
  <div *ngIf="querySelectionsHaveChanged" class="card" style="border: 2.5px solid yellow; border-radius: 0.5em;">
    <div class="card-body runQueryMessage">
      <h5 style="color: yellow"><svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Danger:"><use xlink:href="#exclamation-triangle-fill"/></svg> Warning</h5>  
      <p style="color:#E4E7EB;">Your selections have changed. Please use the "Run Query" button to view updated results.</p>
    </div>
  </div>
</div>
<div *ngIf="validationErrors.length > 0" class="alert alert-danger alert-danger-custom">
  <h5 style="color: white">
    <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Danger:"><use xlink:href="#exclamation-octagon-fill"/></svg> 
    Validation Errors</h5>
  <h6>Please correct the following:</h6>
  <ul *ngFor="let group of groupedValidationErrors">
    <li>{{group.key}}</li>
      <ul *ngFor="let selection of group.values">
        <li>{{selection.errorMessage}}</li>
      </ul>
  </ul>
</div>